import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { TextAutoScrollDirective } from '@frontend/sports/common/ui/text-auto-scroll';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ms-heading',
    templateUrl: 'heading.component.html',
    imports: [TextAutoScrollDirective],
})
export class HeadingComponent {
    @Input() title?: string;
    @HostBinding('class') className = 'heading-bg';
}
